import { render, staticRenderFns } from "./ExamQuestionsModal.vue?vue&type=template&id=9524b4ec&scoped=true"
import script from "./ExamQuestionsModal.vue?vue&type=script&lang=js"
export * from "./ExamQuestionsModal.vue?vue&type=script&lang=js"
import style0 from "./ExamQuestionsModal.vue?vue&type=style&index=0&id=9524b4ec&prod&scoped=true&lang=css"
import style1 from "./ExamQuestionsModal.vue?vue&type=style&index=1&id=9524b4ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9524b4ec",
  null
  
)

export default component.exports